/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { COLORES_DE_TINTA, type Tinta, type Trazo } from "@gestiondoc/shared";
import { pathDeTrazo } from "./trazos.js";

/**
 * La tinta de una hoja llena como SVG, encima de la `HojaISO` en pantalla y en el PDF (fase 3b).
 * Es el mismo dibujo en los dos lados: la capa editable de la web (`CapaDeTinta`) usa
 * `TrazoDeTinta` para cada trazo, y el worker imprime `TintaDeHoja` entera. Los trazos van en
 * píxeles de la hoja a tamaño real, así que el SVG ocupa la hoja entera sin `viewBox`.
 *
 * El resaltador va debajo del lápiz y multiplica el color, como un marcador sobre papel.
 */

export const CSS_TINTA = `
.capa-tinta { position: absolute; inset: 0; width: 100%; height: 100%; z-index: 2; overflow: visible; }
.capa-tinta-resaltador { mix-blend-mode: multiply; }
`;

export function TrazoDeTinta({ trazo, enCurso }: { trazo: Trazo; enCurso?: boolean | undefined }) {
  const d = pathDeTrazo(trazo, !enCurso);
  const color = COLORES_DE_TINTA[trazo.color];
  if (trazo.herramienta === "resaltador") {
    return (
      <path
        d={d}
        fill="none"
        stroke={color}
        strokeWidth={trazo.grosor}
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={0.4}
      />
    );
  }
  return <path d={d} fill={color} />;
}

/** La tinta entera, de solo lectura: lo que imprime el worker. */
export function TintaDeHoja({ tinta }: { tinta: Tinta }) {
  return (
    <svg className="capa-tinta" aria-hidden="true">
      <g className="capa-tinta-resaltador">
        {tinta
          .filter((t) => t.herramienta === "resaltador")
          .map((t) => (
            <TrazoDeTinta key={t.id} trazo={t} />
          ))}
      </g>
      {tinta
        .filter((t) => t.herramienta !== "resaltador")
        .map((t) => (
          <TrazoDeTinta key={t.id} trazo={t} />
        ))}
    </svg>
  );
}
